import React from "react";

const FEEDBACK_OPTIONS = [
  { value: "Like", label: "Yes!" },
  { value: "SoSo", label: "So-so" },
  { value: "Dislike", label: "Not really" },
];

export function FeedbackPanel({
  feedback,
  onSetFeedbackDraft,
  onSubmitFeedback,
}) {
  const rating = feedback?.rating || null;
  const comments = feedback?.comments || "";
  const submitted = !!feedback?.submitted;
  const submitting = !!feedback?.submitting;
  const error = feedback?.error || null;

  if (submitted && rating) {
    const selected = FEEDBACK_OPTIONS.find((o) => o.value === rating);
    return (
      <div className="ai-assistant-modal__feedback ai-assistant-modal__feedback--submitted">
        <span className="ai-assistant-modal__feedback-prompt">
          Thanks for your feedback
        </span>
        <span
          className={`ai-assistant-modal__feedback-pill ai-assistant-modal__feedback-pill--${rating.toLowerCase()} is-active is-readonly`}
        >
          {selected?.label || rating}
        </span>
      </div>
    );
  }

  const expanded = !!rating;

  const handleSelect = (value) => {
    onSetFeedbackDraft({
      rating: value,
      comments,
      submitting: false,
      submitted: false,
      error: null,
    });
  };

  const handleCommentsChange = (event) => {
    onSetFeedbackDraft({
      rating,
      comments: event.target.value,
      submitting: false,
      submitted: false,
      error,
    });
  };

  const handleCancel = () => {
    onSetFeedbackDraft(null);
  };

  const handleSubmit = () => {
    if (!rating || submitting) {
      return;
    }
    onSubmitFeedback(rating, comments);
  };

  return (
    <div className="ai-assistant-modal__feedback">
      <div className="ai-assistant-modal__feedback-row">
        <span className="ai-assistant-modal__feedback-prompt">
          Was this helpful?
        </span>
        <div className="ai-assistant-modal__feedback-pills">
          {FEEDBACK_OPTIONS.map((option) => {
            const isActive = rating === option.value;
            return (
              <button
                key={option.value}
                type="button"
                className={`ai-assistant-modal__feedback-pill ai-assistant-modal__feedback-pill--${option.value.toLowerCase()} ${isActive ? "is-active" : ""}`}
                onClick={() => handleSelect(option.value)}
                disabled={submitting}
              >
                {option.label}
              </button>
            );
          })}
        </div>
      </div>
      {expanded && (
        <div className="ai-assistant-modal__feedback-expanded">
          <textarea
            className="ai-assistant-modal__feedback-textarea"
            rows={2}
            placeholder="Comments (optional)"
            value={comments}
            onChange={handleCommentsChange}
            disabled={submitting}
          />
          {error && (
            <div className="ai-assistant-modal__feedback-error">{error}</div>
          )}
          <div className="ai-assistant-modal__feedback-actions">
            <button
              type="button"
              className="btn custom-btn btn-outline"
              onClick={handleCancel}
              disabled={submitting}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn custom-btn btn-accent"
              onClick={handleSubmit}
              disabled={submitting}
            >
              {submitting ? "Submitting..." : "Submit"}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
